import { Injectable, OnDestroy } from '@angular/core';
import { SubjectLike, Subscription, SubscriptionLike } from 'rxjs';

@Injectable()
export class BaseService implements OnDestroy {
  private readonly _subscriptions: Subscription;

  constructor() {
    this._subscriptions = new Subscription();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  set subscription(value: SubscriptionLike) {
    this._subscriptions.add(value);
  }

  protected completeOnDestroy<T extends SubjectLike<any>>(value: T): T {
    this._subscriptions.add(() => value.complete());
    return value;
  }
}
